<template>
  <div 
    v-cloak
    v-if="mostrar_modal"
    id="coletarDadosConsumidorFinal"
    style="display: block; padding-top: 200px; "
    class="w3-modal">

    <div class="w3-modal-content w3-container w3-animate-zoom" @click.stop>
      <header class="w3-container">
        <h4 class="texto-vermelho w3-center">Dados do consumidor final</h4>
        <span @click="fechar()" class="w3-button w3-display-topright">&times;</span>
      </header> 

      <div class="w3-row-padding w3-margin-bottom">
        <div class="w3-margin-top w3-col m6 s12">
          <label>Tipo de pessoa</label>
          <select class="w3-select w3-border" v-model="dados_consumidor_final.consumidor_final_tipo_pessoa">
            <option value="F">Física</option>
            <option value="J">Jurídica</option>
          </select>
        </div>

        <div class="w3-margin-top w3-col m6 s12" v-show="dados_consumidor_final.consumidor_final_tipo_pessoa == 'J'">
          <label>CNPJ</label>
          <input 
            type="text"
            class="w3-input w3-border"
            v-mask="'##.###.###/####-##'"
            v-model="dados_consumidor_final.cpf_cnpj_consumidor_final">
        </div>

        <div class="w3-margin-top w3-col m6 s12" v-show="dados_consumidor_final.consumidor_final_tipo_pessoa == 'F'">
          <label>CPF</label>
          <input 
            type="text" 
            class="w3-input w3-border"
            v-mask="'###.###.###-##'"
            v-model="dados_consumidor_final.cpf_cnpj_consumidor_final">
        </div>

        <div class="w3-margin-top w3-col m6 s12">
          <label>Nome</label>
          <input 
            type="text"
            maxlength="60"
            class="w3-input w3-border" 
            style="text-transform:uppercase"
            v-model="dados_consumidor_final.consumidor_final_nome">
        </div>

        <div class="w3-margin-top w3-col m6 s12">
          <label>Telefone</label>
          <input 
            type="number"
            maxlength="30"
            class="w3-input w3-border"
            v-model="dados_consumidor_final.consumidor_final_telefone">
        </div>

        <div class="w3-margin-top w3-col m6 s12">
          <label>E-mail</label>
          <input 
            type="text" 
            class="w3-input w3-border"
            style="text-transform:lowercase" 
            v-model="dados_consumidor_final.consumidor_final_email">
        </div>

        <div class="w3-margin-top w3-col m6 s12" v-show="dados_consumidor_final.consumidor_final_tipo_pessoa == 'J'">
          <label>Inscrição estadual</label>
          <input 
            readOnly
            type="text"
            class="w3-input w3-border" 
            v-model="dados_consumidor_final.consumidor_final_inscricao_estadual">
        </div>

        <div class="w3-margin-top w3-col m6 s12" v-show="dados_consumidor_final.consumidor_final_tipo_pessoa == 'F'">
          <label>Data de nascimento</label>
          <input 
            type="text"
            v-mask="'##/##/####'"
            class="w3-input w3-border data" v-model="dados_consumidor_final.consumidor_final_data_nascimento">
        </div>

        <div class="w3-margin-top w3-col m6 s12">
          <label>CEP</label>

          <div class="w3-col">
            <input
              id="campoCEP"
              type="text"
              ref="campoCEP"
              class="w3-input w3-border w3-col"
              :style="getStyleCep()"
              v-model="dados_consumidor_final.consumidor_final_cep"
              v-mask="'#####-###'"
              v-on:keyup.enter="buscarCep(dados_consumidor_final.consumidor_final_cep)"
              :disabled="selecionou_cep"/>

            <button
              class="w3-col w3-button w3-blue"
              style="max-width: 15%;"
              @click="pesquisarCep()"
              v-if="!selecionou_cep && (this.utilizaControleCep == 'S')">
              <i class="fas fa-search"></i>
            </button>

            <button
              class="w3-col w3-button w3-white w3-border"
              style="max-width: 15%;"
              @click="limparCep()"
              v-if="selecionou_cep && (this.utilizaControleCep == 'S')">
              <span>&times;</span>
            </button>
          </div>
        </div>

        <div class="w3-margin-top w3-col m6">
          <label>Logradouro</label> 
          <input
            type="text"
            maxlength="50"
            id="logradouro"
            ref="campoLogradouro"
            class="w3-input w3-border"
            style="text-transform:uppercase"
            :disabled="!editar_logradouro"
            v-model="dados_consumidor_final.consumidor_final_logradouro">
        </div>

        <div class="w3-margin-top w3-col m6 s12">
          <label>Complemento</label>
          <input 
            type="text"
            maxlength="50"
            class="w3-input w3-border"
            style="text-transform:uppercase"
            v-model="dados_consumidor_final.consumidor_final_complemento">
        </div>

        <div class="w3-margin-top w3-col m6 s12">
          <frame-bairro
            ref="frBairro"
            @confirmar="confirmarBairro"
            @limparDados="limparDadosBairro"
            :somenteLeitura="utilizaControleCep"
            :bairroSelecionado="dados_consumidor_final.consumidor_final_bairro_selecionado"
          />
        </div>

        <div class="w3-col s12 w3-center">
          <br>
        </div>
      </div>

      <div class="w3-col s12 w3-center">
        <button 
          class="w3-button w3-theme" 
          @click="confirmarDadosConsumidorFinal()"> 
          <i class="fas fa-check-circle"/>
          Confirmar
        </button>
      </div>
    </div> 

    <pesquisa-CEPs 
      ref="pesquisaCeps"
      @confirmar="confirmarCep"
    />
  </div>
</template>

<script>
  import RCep from '@/components/Rest/RCep.js';
  import RBairro from '@/components/Rest/RBairro.js';
  import FrameBairro from '@/components/Frames/FrameBairro';
  import formatarValorMixin from '@/mixins/formatarValorMixin'
  import PesquisaCEPs from '@/components/Pesquisas/PesquisaCEPs';
  import Biblioteca from '@/components/Repositorio/Biblioteca.js'
  import ROrcamentoVerificarDadosConsumidorFinal from '@/components/Rest/ROrcamento/ROrcamentoVerificarDadosConsumidorFinal.js'

  export default {
    name: 'ColetarDadosConsumidorFinal',

    props: {
      utilizaControleCep: {
        required: true,
        type: String,
        default: 'N'
      },
    },
    
    components:{
      FrameBairro,
      PesquisaCEPs
    },
    
    mixins:[formatarValorMixin],
    
    data() {
      return {
        api: process.env.API,
        mostrar_modal: false,
        dados_consumidor_final: {},

        // Controle de cep
        cep_selecionado: {},
        selecionou_cep: false,
        editar_logradouro: true,
      }
    },  

    methods: {
      async abrir(consumidor_final){
        await this.carregarDadosConsumidorFinal(consumidor_final);
        this.mostrar_modal = true;
      },

      async carregarDadosConsumidorFinal(consumidor_final){
        this.dados_consumidor_final = {};

        if (consumidor_final && Object.keys(consumidor_final).length > 0){
          this.dados_consumidor_final = await JSON.parse(JSON.stringify(consumidor_final));
        } else {
          this.dados_consumidor_final.consumidor_final_tipo_pessoa = 'F';
        }
      },

      fechar(){
        this.mostrar_modal = false;
      },

      getStyleCep(){
        if (this.utilizaControleCep == 'S'){
          return "max-width: 85%";
        } else{
          return "max-width: 100%";
        }
      },

      pesquisarCep() {
        if ((!this.selecionou_cep) && (this.dados_consumidor_final.consumidor_final_cep) && (Biblioteca.numeros(this.dados_consumidor_final.consumidor_final_cep).length == 8)) {
          this.buscarCep(this.dados_consumidor_final.consumidor_final_cep);
        }
        else {
          this.abrirPesquisaCep();
        }
      },

      abrirPesquisaCep() {
        this.$refs.pesquisaCeps.abrir();
      },

      confirmarCep(cep){
        this.buscarCep(cep.cep_id);
      },

      async buscarCep(cep_pesquisa) {
        if (this.utilizaControleCep == 'N'){
          return;
        }

        if (!cep_pesquisa){
          return;
        }

        if ((Biblioteca.numeros(cep_pesquisa).length < 7) || (Biblioteca.numeros(cep_pesquisa).length > 8)) {
          Biblioteca.exclamar('Informe um CEP válido!');
          return;          
        }

        let parametros = {
          cep_id: cep_pesquisa
        }

        try {
          let retorno = await RCep.buscarCepPorId(
            this.axios,
            parametros
          );

          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          await this.carregarCep(retorno.dados);
        }
        catch(e) {
          Biblioteca.exclamar(e.message);
        }
      },

      async carregarCep(cep) {
        this.cep_selecionado = JSON.parse(JSON.stringify(cep));

        this.dados_consumidor_final.consumidor_final_cep = this.cep_selecionado.cep_formatado;
        this.dados_consumidor_final.consumidor_final_logradouro = this.cep_selecionado.logradouro;

        if (Biblioteca.stringVazia(this.dados_consumidor_final.consumidor_final_logradouro)) {
          this.editar_logradouro = true;
        }
        else {
          this.editar_logradouro = false;
        }

        let bairro_id = Biblioteca.valorInt(this.cep_selecionado.bairro_id);
        if (bairro_id > 0) {
          await this.carregaBairroSelecionado(bairro_id);
        }

        this.selecionou_cep = true;
      },

      limparCep() {
        this.dados_consumidor_final.consumidor_final_cep = '';
        this.cep_selecionado = {};
        this.selecionou_cep = false;
        this.$refs.frBairro.limparDados();

        if (!this.editar_logradouro) {
          this.dados_consumidor_final.consumidor_final_logradouro = '';
        }

        this.$nextTick(() => this.$refs.campoCEP.focus());
      },

      async buscarBairro(bairro_id){
        try{
          if ((!bairro_id) || (bairro_id <= 0)) {
            return {};
          }

          let parametros = {
            tipo: 'COD',
            chave: bairro_id
          }

          let retorno = await RBairro.pesquisarBairros(this.axios, parametros);

          if (retorno.houve_erro != 'N') {
            throw new Error(retorno.mensagem);
          }

          return await JSON.parse(JSON.stringify(retorno.dados.bairros[0]));
        }
        catch (e) {
          Biblioteca.exclamar('Não foi possível buscar o bairro ' + bairro_id + '! ' + e.message);
          return {};
        }
      },

      async carregaBairroSelecionado(bairro_id) {
        try{
          if ((!bairro_id) || (bairro_id <= 0)) {
            this.dados_consumidor_final.consumidor_final_bairro_selecionado = {};
            return;
          }
       
          this.dados_consumidor_final.consumidor_final_bairro_selecionado = await this.buscarBairro(bairro_id);

          try{
            await this.$refs.frBairro.carregar(this.dados_consumidor_final.consumidor_final_bairro_selecionado);
          } catch (e) {
            // fazer nada
          }
        }
        catch (e) {
          Biblioteca.exclamar('Não foi possível carregar o bairro ' + bairro_id + '! ' + e.message);
        }
      },

      confirmarBairro(bairro){
        this.dados_consumidor_final.consumidor_final_bairro_selecionado = JSON.parse(JSON.stringify(bairro));  
      },

      limparDadosBairro(){
        this.dados_consumidor_final.consumidor_final_bairro_selecionado = {};
      },

      tratarDadosConsumidorFinal(){
        if (this.dados_consumidor_final.consumidor_final_nome){
          this.dados_consumidor_final.consumidor_final_nome = this.dados_consumidor_final.consumidor_final_nome.toUpperCase();
        }

        if (this.dados_consumidor_final.consumidor_final_tipo_pessoa){
          this.dados_consumidor_final.consumidor_final_tipo_pessoa = this.dados_consumidor_final.consumidor_final_tipo_pessoa.toUpperCase();
        }

        if (this.dados_consumidor_final.consumidor_final_logradouro){
          this.dados_consumidor_final.consumidor_final_logradouro = this.dados_consumidor_final.consumidor_final_logradouro.toUpperCase();
        }

        if (this.dados_consumidor_final.consumidor_final_email){
          this.dados_consumidor_final.consumidor_final_email = this.dados_consumidor_final.consumidor_final_email.toLowerCase();
        }

        if (this.dados_consumidor_final.consumidor_final_telefone){
          this.dados_consumidor_final.consumidor_final_telefone = Biblioteca.numeros(this.dados_consumidor_final.consumidor_final_telefone);
        }

        if (this.dados_consumidor_final.complemento_consumidor_final){
          this.dados_consumidor_final.complemento_consumidor_final = this.dados_consumidor_final.complemento_consumidor_final.toUpperCase();
        }

        if (this.dados_consumidor_final.complemento_consumidor_final){
          this.dados_consumidor_final.complemento_consumidor_final = this.dados_consumidor_final.complemento_consumidor_final.toUpperCase();
        }

        this.dados_consumidor_final.bairro_cons_final_id = 0;
        if 
          (
            (this.dados_consumidor_final.consumidor_final_bairro_selecionado) && 
            (this.dados_consumidor_final.consumidor_final_bairro_selecionado.bairro_id)
          )
        {
          this.dados_consumidor_final.bairro_cons_final_id = this.dados_consumidor_final.consumidor_final_bairro_selecionado.bairro_id; 
        }
      },

      async confirmarDadosConsumidorFinal() {
        try {
          let parametros = {
            nome_consumidor_final: this.dados_consumidor_final.consumidor_final_nome,
            logradouro_consumidor_final: this.dados_consumidor_final.consumidor_final_logradouro,
            cpf_cnpj_consumidor_final: this.dados_consumidor_final.cpf_cnpj_consumidor_final,
            tipo_pessoa_consumidor_final: this.dados_consumidor_final.consumidor_final_tipo_pessoa,
            email_consumidor_final:  this.dados_consumidor_final.consumidor_final_email,
            data_nascimento_cons_final: this.dados_consumidor_final.consumidor_final_data_nascimento,
            telefone_consumidor_final: this.dados_consumidor_final.consumidor_final_telefone,
            bairro_cons_final_id: this.dados_consumidor_final.consumidor_final_bairro_selecionado.bairro_id,
            complemento_consumidor_final: this.dados_consumidor_final.consumidor_final_complemento,
            cep_consumidor_final: this.dados_consumidor_final.consumidor_final_cep,
            inscricao_estadual_consumidor_final: this.dados_consumidor_final.consumidor_final_inscricao_estadual 
          }

          let retorno = await ROrcamentoVerificarDadosConsumidorFinal.verificarDadosConsumidorFinal(this.axios, parametros);

          if (retorno.houve_erro != 'N'){
            throw new Error(retorno.mensagem);
          }

          // Verificando se houve algum bloqueio retornado
          if (retorno.dados.houve_bloqueio == 'S'){
            if (retorno.dados.mensagem){
              retorno.dados.mensagem = retorno.dados.mensagem.replace(/\\n/g, String.fromCharCode(13) + String.fromCharCode(10));
            }

            await swal(retorno.dados.mensagem);
          } else {
            // Executando questionamentos
            if (retorno.dados.questionar){
              let abortar_operacao = false;
              for (let i = 0; i < retorno.dados.questionar.length; i++) {
                await swal(
                  retorno.dados.questionar[i].mensagem, 
                  {
                    buttons: {
                      sim: "Sim",
                      nao: "Não"                
                    },
                  }
                ).then((value) => {
                  switch (value) {
                    case "nao": 
                      abortar_operacao = true;
                  }
                });

                if (abortar_operacao){
                  return;
                }
              }
            }

            // Verificando se o cpf já existe nos cadastros
            if (Biblioteca.valorInt(retorno.dados.cadastro_existente_id) > 0){
              if (retorno.dados.mensagem_lista_tipo_pessoa) {
                retorno.dados.mensagem_lista_tipo_pessoa = retorno.dados.mensagem_lista_tipo_pessoa.replace(/\\n/g, String.fromCharCode(13) + String.fromCharCode(10));
              }

              await swal(
                {
                  title: retorno.dados.titulo_aviso_tipo_pessoa,
                  text: retorno.dados.mensagem_lista_tipo_pessoa
                }
              );

              // Carregando cliente encontrado na tela de orçamentos
              await this.$emit('carregarDadosClienteExistente', retorno.dados.cadastro_existente_id);
              await this.fechar();
            } else {
              // Alterando os dados do consumidor final na tela de orçamentos
              await this.tratarDadosConsumidorFinal();
              await this.$emit('carregarDadosConsumidorFinal', this.dados_consumidor_final);
              await this.fechar();
            }
          }
        }
        catch(e) {
          Biblioteca.exclamar(e.message);
        }
      },
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Orcamentos/ColetarDadosConsumidorFinal.vue